import { ApiResult, HttpClient } from "../http.js";
import { CvrLookupResult } from "../types/cvr.js";

export class CvrApi {
  constructor(private readonly http: HttpClient) {}

  lookup(number: string): Promise<ApiResult<CvrLookupResult>> {
    return this.http.get<CvrLookupResult>("/api/cvr/lookup", { query: { number } });
  }
}
